export default __webpack_public_path__ + "static/media/prev.cc93fbc2.svg";